module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/san_marco_wallpaper_extended-26a59fc822ca4b1cf80aacc226b9201e.jpg";